import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { AppSidebarComponent } from './app-sidebar.component';

@NgModule({
  declarations: [AppSidebarComponent],
  imports: [CommonModule, RouterModule, NgbTooltipModule],
  exports: [AppSidebarComponent],
})
export class AppSidebarModule {}
